/**
 * ADR-0185 — inputs-changed detection for the board shell (canonicalize before
 * a "did it change?" compare). Shell-side: it reads only the overlay contract
 * (active disruption entries vs the standing solve's snapshot) and knows
 * nothing about what any view draws.
 */

type OverlayShape = { kind: string; subject: Record<string, unknown>; starts_at: string | null; ends_at: string | null };

function canonicalOverlay(o: OverlayShape): string {
  const subject = Object.fromEntries(Object.entries(o.subject ?? {}).sort(([a], [b]) => a.localeCompare(b)));
  return JSON.stringify({
    kind: o.kind,
    subject,
    starts_at: o.starts_at ? new Date(o.starts_at).toISOString() : null,
    ends_at: o.ends_at ? new Date(o.ends_at).toISOString() : null,
  });
}

/**
 * True when the active disruption set differs from what the standing solve was
 * given — the "Inputs changed — re-solve." light. Canonicalized both sides so
 * a timestamp-format or key-order difference never fails open.
 */
export function overlaysDiffer(
  active: Array<{ kind: string; subject: Record<string, unknown>; starts_at: string; ends_at: string | null }>,
  snapshot: OverlayShape[]
): boolean {
  const a = active.map((o) => canonicalOverlay(o)).sort();
  const b = snapshot.map((o) => canonicalOverlay(o)).sort();
  return JSON.stringify(a) !== JSON.stringify(b);
}
